import { APP_ID, NgModule, isDevMode, signal } from '@angular/core';
import { AgrBrowserModule } from '@next/core-lib/browser';
import { parseAgrEnvironment } from '@next/core-lib/environment';
import { ENVIRONMENT_MAPPER } from '@next/core-lib/environment-browser';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { environment } from 'src/environments/environment';

import { AppComponent } from './app.component';
import { AppModule } from './app.module';

declare global {
  var CONFIG_BUILD_ID: string | undefined;
}

const loadedConfig = signal(environment);
export const setupRuntimeConfig = (async () => {
  try {
    const buildId = globalThis.CONFIG_BUILD_ID;
    const configUrl = buildId ? `/assets/config.json?v=${buildId}` : '/assets/config.json';
    const response = await globalThis.fetch(configUrl);
    if (response.ok) {
      const config = await response.json();
      loadedConfig.set({ ...environment, ...parseAgrEnvironment(config) });
    } else {
      console.warn('No runtime configuration found, using default environment settings.');
    }
  } catch (e) {
    console.warn('Failed to load runtime environment variables', e);
  }
})();

@NgModule({
  imports: [AppModule, AgrBrowserModule],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: ENVIRONMENT_MAPPER,
      useFactory: () => {
        return loadedConfig();
      },
    },
    {
      provide: APP_ID,
      useFactory: () => loadedConfig().APPLICATION_NAME,
    },
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75,
      connectInZone: false,
    }),
  ],
})
export class AppBrowserModule {}
